import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { FontWeights } from '../../enums/font-weights';
import { DisplaySizes } from '../../enums/typography-display-sizes';
import { cn } from '../../utils/cn';
import { displayVariants } from '../../variants/typography-display-variants';
import type { DisplayProps } from './types';

const Display = React.forwardRef<HTMLElement, DisplayProps>(
  (
    {
      as: Component = 'span',
      asChild = false,
      className,
      size = DisplaySizes.MD,
      weight = FontWeights.REGULAR,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : Component;
    return (
      <Comp
        ref={ref}
        data-slot='typography-display'
        className={cn(
          'antialiased',
          displayVariants({ size, weight }),
          className
        )}
        data-size={size}
        data-weight={weight}
        {...props}
      />
    );
  }
);
Display.displayName = 'Display';

export { Display };
